import ImgPopupLayer from "../../theme/img-popup-layer/img-popup-layer";

var anchorToSuffixMap = {};
var suffixToAnchorMap = {};
var imgElementCount = 0;
var imgLoadedCount = 0;

var _cumulativeOffset = function (element) {
    if (!element) {
        return null;
    }
    var top = 0, left = 0;
    do {
        top += element.offsetTop || 0;
        left += element.offsetLeft || 0;
        element = element.offsetParent;
    } while (element);

    return {
        top: top,
        left: left
    };
};

var _toScrollAnchorByIdx = function (current_anchor_idx) {
    var tmpOffset = _cumulativeOffset($("#anchor_idx_" + current_anchor_idx).get(0));
    var toSetScrollTop = tmpOffset.top - 90; // 90 is from exp.

    // RWD modofication
    if ($(".menu-header-zone").css("display") !== "none") {
        // this value should be the same as "$menu-header-zone-height" in scss
        toSetScrollTop -= 60;
    }

    $("html, body").animate({
        scrollTop: toSetScrollTop
    }, 200, 'linear');
};

var scrollToAnchor_byClickingAncherElem = function (current_anchor_idx) {
    _toScrollAnchorByIdx(current_anchor_idx);
    // without this ".pushState", "#something" will not show in browser URL
    window.history.pushState(null, null,
        window.location.pathname
        + anchorToSuffixMap[current_anchor_idx]);
};

var toShowLeftIndexPanel_inRWDSmallSize = function () {
    $(".left-index-side-bar-zone").css({ "display": "inline-block" });
    $(".left-index-side-bar-zone__bg-shield-in-RWD-small").css({ "display": "inline-block" });
};

var toHideLeftIndexPanel_inRWDSmallSize = function () {
    $(".left-index-side-bar-zone").css({ "display": "" });
    $(".left-index-side-bar-zone__bg-shield-in-RWD-small").css({ "display": "" });
};

var toRenderLeftSidePanel = function () {
    // --------------------------------------------------
    // for left side bar creation
    // --------------------------------------------------
    var indexSideBar_jqElem = $(".left-index-side-bar-zone");
    var indexSideBarRootUl_jqElem = $("<ul class='left-index-side-bar-zone_root_ul'></ul>");
    indexSideBar_jqElem.append(indexSideBarRootUl_jqElem);

    var anchor_idx = 0;
    var currentSubUl_jqElem = null;
    $("#__articleContentDivID").find("h1, h2, h3, h4, h5, h6").each(function () {
        $(this).attr("id", "anchor_idx_" + anchor_idx);
        var aTagElem = $(this).find("a");
        if (aTagElem.attr("href")) {
            var suffix = aTagElem.attr("href");
            anchorToSuffixMap[anchor_idx] = suffix;
            suffixToAnchorMap[suffix] = anchor_idx;

            var hText = $(this).text();
            $(this).html(hText);
            var anchorSymbol = $("<a class='chainImgAnchor' href='" + suffix + "'> </a>");
            $(this).append(anchorSymbol);
        } else {
            anchorToSuffixMap[anchor_idx] = "";
        }
        var suffix = anchorToSuffixMap[anchor_idx];
        var tmpLiElem = $("<li><a data-anchor-idx='" + anchor_idx + "' name='leftTreeElemAnchor' href='" + suffix + "'>" + $(this).text() + "</a></li>");
        if ($(this).is("h1")) {
            indexSideBarRootUl_jqElem.append(tmpLiElem);
            currentSubUl_jqElem = $("<ul class='left-index-side-bar-zone_sub_ul'></ul>");
            indexSideBarRootUl_jqElem.append(currentSubUl_jqElem);
        } else if ($(this).is("h2")) {
            currentSubUl_jqElem.append(tmpLiElem);
        }

        anchor_idx++;
    });

    $("a[name='leftTreeElemAnchor']").each(function () {
        $(this).on("click", function (evt) {
            var current_anchor_idx = $(this).get(0).dataset.anchorIdx;
            scrollToAnchor_byClickingAncherElem(current_anchor_idx);
            toHideLeftIndexPanel_inRWDSmallSize(); // no effect when we are not in RWD small size
            evt.preventDefault();
        });
    });

    // old code keep for ref. // $("a[class='chainImgAnchor']").each(function () {
    //
    // "href^" means "starts with"
    $("#__articleContentDivID a[href^='#']").each(function () {
        $(this).on("click", function (evt) {
            var suffix = $(this).attr("href");
            var current_anchor_idx = suffixToAnchorMap[suffix];
            // if "current_anchor_idx" is "undefined" means this "suffix" (#xxx) is not an from H1 / H2.
            if (current_anchor_idx !== undefined) {
                scrollToAnchor_byClickingAncherElem(current_anchor_idx);
            }
            evt.preventDefault();
        });
    });

};

var toFillMenuHedaerTitle = function () {
    var oriText = $("#menu-title__md-article-mode").text().trim();
    if (!oriText) {
        var titleStr = $("#__articleContentDivID").find("h1").first().text();
        $("#menu-title__md-article-mode").text(titleStr);
    }
};

var scrollToAnchor_byVisitingHashInURL = function () {
    var hashSuffix = window.location.hash;
    // console.log("hashSuffix: " + hashSuffix);
    // console.log("imgLoadedCount: " + imgLoadedCount);
    // console.log("imgElementCount: " + imgElementCount);
    if (hashSuffix && imgLoadedCount >= imgElementCount) {
        var current_anchor_idx = suffixToAnchorMap[hashSuffix];
        if (current_anchor_idx) {
            _toScrollAnchorByIdx(current_anchor_idx);
        }
    }
};

var checkFooterShowInScreenAndAdjustLeftSidePanel = function () {
    var footer_top_offset = _cumulativeOffset($(".theme-footer").get(0)).top;
    var scroll_top_offset = $(window).scrollTop();
    if (scroll_top_offset + $(window).height() >= footer_top_offset) {
        var footer_top_to_bottom_height = $(window).height() - (footer_top_offset - scroll_top_offset);
        // js version of "calc(100% - 70px - footer_top_to_bottom_height)"
        var tmp_calc_height = $(window).height() - 70 - footer_top_to_bottom_height;
        $(".left-index-side-bar-zone").css({ "height": tmp_calc_height + "px" });
    } else {
        $(".left-index-side-bar-zone").css({ "height": "" });
    }
};

// ==================================================
$(function () {
    // --------------------------------------------------
    // to make image popup open
    // --------------------------------------------------
    var imgPopupLayer = new ImgPopupLayer();
    imgElementCount = 0;
    imgLoadedCount = 0;
    $("img").each(function () {
        var tmpSrcStr = $(this).attr("src");
        var tmpAltStr = $(this).attr("alt");

        if (this.id !== "__img_popup_layer__imgID") {
            imgElementCount++;
            $(this).on("click", function () {
                imgPopupLayer.toShow(tmpSrcStr, tmpAltStr);
            });
            var isImgLoaded = this.complete && this.naturalHeight !== 0;
            if (isImgLoaded) {
                imgLoadedCount++;
            } else {
                $(this).one("load", function () {
                    imgLoadedCount++;
                    if (imgLoadedCount >= imgElementCount) {
                        console.log("img loaded and scrollToAnchor_byVisitingHashInURL");
                        scrollToAnchor_byVisitingHashInURL();
                    }
                });
            }
        }

    });

    // --------------------------------------------------
    // to modify left index zone when scroll to footer
    // --------------------------------------------------
    $(window).scroll(function (event) {
        checkFooterShowInScreenAndAdjustLeftSidePanel();
    });

    // --------------------------------------------------
    // defind menu-icon function in RWD small size
    // --------------------------------------------------
    $("#menu-icon__md-article-mode").on("click", function (evt) {
        toShowLeftIndexPanel_inRWDSmallSize();
    });
    $(".left-index-side-bar-zone__bg-shield-in-RWD-small").on("click", function (evt) {
        toHideLeftIndexPanel_inRWDSmallSize();
    });

    // --------------------------------------------------
    toRenderLeftSidePanel();

    toFillMenuHedaerTitle();

    $(window).on('load', function () {
        scrollToAnchor_byVisitingHashInURL();
    });

    checkFooterShowInScreenAndAdjustLeftSidePanel();
});
